import { useEffect, cloneElement } from "react";
import useMeasure from "react-use-measure";

import { useBanners } from "./useBanners";

import * as styles from "./Banners.styles";

const Banners = () => {
  const { banners, setBannersHeight } = useBanners();
  const [ref, bounds] = useMeasure();

  useEffect(() => {
    if (bounds) {
      setBannersHeight(bounds.height);
    }
  }, [bounds]);

  const renderBanners = () => {
    return banners.map((banner, index) => {
      return cloneElement(banner.content, { key: index });
    });
  };

  return (
    <div ref={ref} css={styles.banners} role="banner">
      {renderBanners()}
    </div>
  );
};

export { Banners };
